import {
  LineageBrowserDataCatalogProvider,
  VizPortalDataCatalogProviderProps,
} from '@tableau/data-catalog-shared';
import * as React from 'react';
import { CatalogBrowser, CatalogBrowserProps } from './CatalogBrowser';

export type EmbeddableCatalogBrowserProps = VizPortalDataCatalogProviderProps &
  CatalogBrowserProps;

export function EmbeddableCatalogBrowserWithoutRouter(
  props: EmbeddableCatalogBrowserProps
): JSX.Element {
  return (
    <LineageBrowserDataCatalogProvider {...props}>
      <CatalogBrowser
        hideLaunchEditOnMobile={props.hideLaunchEditOnMobile}
        newFlowFromCatalog={props.newFlowFromCatalog}
        projectIdForNewDocuments={props.projectIdForNewDocuments}
        renderDatabasesExplorer={props.renderDatabasesExplorer}
        renderTablesExplorer={props.renderTablesExplorer}
        registerErrorStore={props.registerErrorStore}
        unregisterErrorStore={props.unregisterErrorStore}
        featureFlags={props.featureFlags}
        webClientResult={props.webClientResult}
      />
    </LineageBrowserDataCatalogProvider>
  );
}
